import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef} from '@angular/core';
import { ModalService } from 'ng-bootstrap-modal';
import { SignupDialogComponent } from '../../signup-dialog/signup-dialog.component';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { SignupService } from '../../signup/service/signup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {BroadcastService} from '@azure/msal-angular';
import { MsalService} from '@azure/msal-angular';
import {Subscription} from 'rxjs/Subscription';
import { ServiceUrlsService } from '../../common-service/service-urls/service-urls.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { Lightbox } from 'ngx-lightbox';



@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss']
})
export class BodyComponent implements OnInit, OnDestroy {

  contactEmail: string;

  public _albums: any = [];

  @ViewChild('signupFormElement')
  private signupFormElement: ElementRef;

  @ViewChild('resendVerificationEmailForm')
  private resendVerificationEmailForm: ElementRef;

  supportForm: FormGroup;

  private subscription: Subscription;

  signupForm: FormGroup;
  isSignupError = false;
  signUpErrorMessage: string;
  signUpSuccessMessage: string;
  signUpSuccess = false;
  verificationEmailSent = false;
  showAlreadyRegisteredForm = false;


  constructor(private modalService: ModalService,
    private fb: FormBuilder,
    private signupService: SignupService,
    private spinnerService: NgxSpinnerService,
    private broadcastService: BroadcastService,
    private authService: MsalService,
    private serviceUrlsService: ServiceUrlsService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private _lightbox: Lightbox) {
    for (let i = 1; i <= 4; i++) {
      const src = 'assets/img/screenshot/lightbox/' + i + '.png';
      const caption = 'Image ' + i + ' caption here';
      const thumb = 'assets/img/screenshot/lightbox/' + i + '.png';
      const album = {
        src: src,
        caption: caption,
        thumb: thumb
      };
      this._albums.push(album);
    }
  }

  ngOnInit() {
    this.isSignupError = false;
    this.signUpSuccess =  false;
    this.verificationEmailSent = false;
    this.showAlreadyRegisteredForm =  false;
    this.signUpErrorMessage = '';
    this.signUpSuccessMessage = '';
    this.buildForm();
    this.buildSignUpForm();
  }


  openModal(event) {
    console.log('Open Modal');
    console.log(event);
    event.preventDefault();
    this.modalService.open('signupDialog');
  }

  openReadMoreModal(event) {
    console.log('Open read more Modal');
    console.log(event);
    event.preventDefault();
    this.modalService.open('signupDialog');
  }

  msSignup() {
        // this.authService.loginRedirect(["user.read"]);
        this.router.navigate(['free-trial']);
  }

  logout() {
    this.authService.logout();
  }

  // openBS3Modal(template: TemplateRef<any>) {
  //   this.modalRef = this.modalService.show(template);
  // }

  openMsSignupModal() {
    console.log('Open MS Signup Modal');
    this.modalService.open('msSignupDialog');
  }

  buildSignUpForm() {

    this.signupForm = this.fb.group({
      contactName: ['', Validators.required],
      contactEmail: ['', [
          Validators.required,
          Validators.email
        ]
      ],
      clientName: ['', Validators.required],
      contactPhone: [''],
      acceptTermsAndPrivacy: [false, Validators.required],
      recaptcha: false
    });

  }

  sumbitSignup() {

    console.log(this.signupForm.value);

    const signupFormData = this.signupForm.value;

    const signUpObject = {contactName: signupFormData.contactName, contactEmail: signupFormData.contactEmail,
                          clientName: signupFormData.clientName, contactPhone: signupFormData.contactPhone,
                          clientType: '',
                         };

   console.log(signUpObject);

    this.spinnerService.show();

     this.signupService.signup(signUpObject).subscribe(response => {
        const code = response.code;
        console.log(response);
        if (code === '200' || code === 200) {
            this.spinnerService.hide();
            this.signUpSuccess = true;
            // this.router.navigate(['signup-success', signupFormData.contactEmail]);
        } else {
            this.isSignupError =  true;
            this.signUpErrorMessage = response.message;
            this.spinnerService.hide();
        }
    },
      err => {
            console.log(err);
           this.isSignupError =  true;
           this.signUpErrorMessage = err.errorMessage;
           this.spinnerService.hide();
    });

  }


  buildForm() {

    this.supportForm = this.fb.group({
      contactName: ['', Validators.required],
      contactEmail: ['', [
          Validators.required,
          Validators.email
        ]
      ],
      emailContent: ['', Validators.required]
    });

  }


  sendSupportEmail() {
      console.log(this.supportForm.value);

     const contactEmailObject = this.supportForm.value;

     console.log(contactEmailObject);
     this.spinnerService.show();

     // setInterval(function() { alert('Popup window!'); }, 500);

     this.signupService.sendSupportEmail(contactEmailObject).subscribe(response => {
        const status = response.status;
        console.log(response);
        if (status === '100' || status === 100) {
            // this.resendEmailMessage = response.message;
            // this.signUpSuccess =  true;
            this.toastrService.success('Our support team will contact you shortly!', 'Your query has been submited!');
            this.spinnerService.hide();

            this.supportForm.reset();
        } else {
            // this.resendEmailMessage = response.message;
            this.toastrService.error('Failed!',
                  'An error occoured while sending message!');
            this.spinnerService.hide();
        }
    },
      err => {
          console.log(err);
           // this.resendEmailMessage = err.message;
           this.toastrService.error('An error occoured while sending message!', 'Failed!');
           this.spinnerService.hide();
    });
  }

  // msSignup() {
  //   //console.log('opening mslogin url');
  //     window.open("http://localhost:3000/microsoft", "_self");
  // }

  scrollToTop() {
      window.scrollTo(0, 0);
  }

  scrollToElement($element): void {
    console.log($element);
    $element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }

  ngOnDestroy() {
    this.broadcastService.getMSALSubject().next(1);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onScriptLoad() {
        // console.log('Google reCAPTCHA loaded and is ready for use!')
  }

  onScriptError() {
       // console.log('Something went long when loading the Google reCAPTCHA')
  }

  generateVerificationCode(length): string {

     let text = '';
     const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

     for (let i = 0; i < length; i++) {
         text += possible.charAt(Math.floor(Math.random() * possible.length));
     }

     return text;
  }

  clickAlreadyRegistered() {
      this.isSignupError =  false;
      this.showAlreadyRegisteredForm =  true;
      // console.log(this.signupFormElement.nativeElement.classList.add('hide'));

      this.signupFormElement.nativeElement.classList.add('hide');
      // this.resendVerificationEmailForm.nativeElement.classList.remove('hide')
     // this.signupFormElement.nativeElement.add('hide');
  }

  clickSignUpLink() {
     this.isSignupError =  false;
     this.showAlreadyRegisteredForm =  false;
     this.signupFormElement.nativeElement.classList.remove('hide');
     // this.resendVerificationEmailForm.nativeElement.classList.add('hide')
  }

resendVerificationEmail() {

    // console.log(this.contactEmail);

    const clientObject = {contactEmail: this.contactEmail};

    this.isSignupError =  false;

    this.spinnerService.show();

     this.signupService.resendVerificationEmail(clientObject).subscribe(response => {
      const code = response.code;
        console.log(response);
        if (code === '200' || code === 200) {
            this.signUpErrorMessage = response.message;
            this.spinnerService.hide();
            this.verificationEmailSent = true;
            // this.router.navigate(['signup-success', signupFormData.contactEmail]);
        } else {
            this.isSignupError =  true;
            this.signUpErrorMessage = response.message;
            this.spinnerService.hide();
        }
    },
      err => {
            console.log(err);
           this.isSignupError =  true;
           this.signUpErrorMessage = err.errorMessage;
           this.spinnerService.hide();
    });

  }

termsOfPrivacyPolicy() {
    window.open(this.serviceUrlsService.wesiteBaseUrl + 'privacy-policy');
}

open(index: number): void {
  // open lightbox
  console.log('Image index --------- ', index);
  this._lightbox.open(this._albums, index);
}

close(): void {
  // close lightbox programmatically
  this._lightbox.close();
}

}



// WEBPACK FOOTER //
// ./src/app/layout/body/body.component.ts